import { jsx as _jsx } from "react/jsx-runtime";
import { Taskpane } from './taskpane/Taskpane';
import { ToastProvider } from './components/ui/toast';
import { TooltipProvider } from './components/ui/tooltip';
import { AuthProvider } from './contexts/AuthContext';
import './App.css';
console.warn('[App] MODULE LOADED');
function App() {
    console.warn('[App] Component rendered');
    return (_jsx(AuthProvider, { children: _jsx(TooltipProvider, { delayDuration: 200, children: _jsx(ToastProvider, { children: _jsx(Taskpane, {}) }) }) }));
}
export default App;
//# sourceMappingURL=App.js.map